module.exports = __webpack_public_path__ + "static/media/RP-23.40ac2dfd.pdf";